import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { UsersService } from '../Services/users.service';
import { BeneficiaryService } from '../Services/beneficiary.service';
import { AgencyService } from '../Services/Agency.service';
import { AgencyRightsProperties } from '../Models/AgencyRightsProperties';
import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule, FormBuilder } from '@angular/forms';
import { NgSelectModule, NgSelectComponent, NgSelectConfig, NgOption } from '@ng-select/ng-select';
/*import { SelectDropDownModule } from 'ngx-select-dropdown';*/
/*import { ActiveBeneficiaryAccount } from '../Models/ActiveClasses';*/
import { ActiveAgencies, ActiveBenificaryAccount } from '../Models/ActiveClasses';
import { BeneficiaryAccountAllocationProperties, GetAllocatedAccountsProperties } from '../Models/BeneficiaryAccountProperties';
import { BaseDataBeneficiaryAccountsAllocation } from '../Models/ActiveBeneficiaryAccounts';
import { Router } from '@angular/router';
import * as $ from "jquery";
import { Observable, of } from 'rxjs';
import { DxDataGridComponent } from 'devextreme-angular';
declare const NaveStartup: any;
import { } from '@fortawesome/free-regular-svg-icons';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'beneficiary-accounts-allocation',
  templateUrl: './beneficiary-accounts-allocation.component.html',
  styleUrls: ['./beneficiary-accounts-allocation.component.css']
})
  @NgModule({ imports: [FormsModule, NgSelectModule, NgSelectComponent, NgSelectConfig] })

export class BeneficiaryAccountsAllocationComponent {
  public vari: string;
  public pari: string;
  constructor(private usersService: UsersService, private http: HttpClient, private router: Router, private beneficiaryService: BeneficiaryService, private agencyService: AgencyService) {
    };
  fatrash = faTrash;
  faedit = faEdit;
  beneficiaryCObj = new BaseDataBeneficiaryAccountsAllocation();
  accAllocationObj = new BeneficiaryAccountAllocationProperties();
  agencyRightsData = new AgencyRightsProperties();
  beneficiaryAllocationData: GetAllocatedAccountsProperties[] = [];
  allData$: BaseDataBeneficiaryAccountsAllocation;
  agencies$: Observable<ActiveAgencies[]>;
  accounts$: Observable<ActiveBenificaryAccount[]>;
  allocatedAgencyId: string[] = [];
  accountNo: string[] = [];
  benficloader: boolean = false;
  selectedValue: string;
  @ViewChild('userGrid', { static: false }) dataGrid: DxDataGridComponent;
  collapsed = false;
  
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  
  ngOnInit() {
    NaveStartup();
    //console.log(this.agencyRightsData.beneficiaryAccount);
    //if (this.agencyRightsData.beneficiaryAccount == false) {
    //  document.querySelector(".cms_card").classList.add("hidden-alloc")
    //}
     //= 
    this.getActiveAccounts();

    this.getBeneficiaryAllocationData(localStorage.getItem("AgencyId"));
    this.getAgencyRightsData();
    this.checkBeneficaryAccountRight();

  }
  checkBeneficaryAccountRight() {
    this.beneficiaryService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      if (data) {

        $("#btnSave").removeAttr("disabled");
      }
      else {
        $("#btnSave").attr("disabled", "disabled");
      }
    });
  }

  //LoadEditableData() {
  //  try {
  //    if (localStorage.getItem("allocationId") != undefined || localStorage.getItem("allocationId") != null) {
  //      let allocationId = Number(localStorage.getItem("allocationId"));
  //      if (allocationId != 0 || allocationId != null) {
  //        this.beneficiaryService.getBeneficiaryAccAllocationById(allocationId).subscribe((data) => {
  //          this.accAllocationObj = data[0] as BeneficiaryAccountAllocationProperties;
  //          localStorage.removeItem("allocationId");
  //        });
  //      }
  //    }
  //  }
  //  catch (e) {
  //    //console.log(e);
  //  }
  //}

  onSubmit() {
    if (this.allocatedAgencyId.length > 0 && this.accountNo.length > 0) {
    if (this.allocatedAgencyId[0] == "ALL") {
      this.allocatedAgencyId = [];
      for (let i = 0; i < this.allData$.agencies.length; i++) {
        if (this.allData$.agencies[i].agencyId!="ALL")
          this.allocatedAgencyId.push(this.allData$.agencies[i].agencyId);
      }
    }
    let accountsAllocation: BeneficiaryAccountAllocationProperties[] = [];
    if (this.accAllocationObj.allocationId == 0) {
      for (let i = 0; i < this.allocatedAgencyId.length; i++) {
        for (let k = 0; k < this.accountNo.length; k++) {
          let accAllocation = new BeneficiaryAccountAllocationProperties();
          accAllocation.accountNo = this.accountNo[k];
          accAllocation.allocatedAgencyId = this.allocatedAgencyId[i];
          accAllocation.creationUser = Number(localStorage.getItem("UserId"));
          accAllocation.agencyId = localStorage.getItem("AgencyId");
          accAllocation.isActive = this.accAllocationObj.isActive;
          accountsAllocation.push(accAllocation);
        }
      }
      
      this.benficloader = true;
        this.beneficiaryService.createBeneficiaryAccAllocation(accountsAllocation).subscribe((data => {
          if (data == true) {
            this.benficloader = false;
            $("#response-screen").show();
            document.getElementById("response-screen").innerHTML = "Data created Successfully :)"
            $("#response-screen").delay(5000).hide(1000);
          }
          else {
            this.benficloader = false;
            $("#response-screen").show();
            document.getElementById("response-screen").innerHTML = "Error occured while creating Data :("
            $("#response-screen").delay(5000).hide(1000);
          }
          this.getBeneficiaryAllocationData(localStorage.getItem("AgencyId"));
          this.accAllocationObj = new BeneficiaryAccountAllocationProperties();
          this.benficloader = false;
        }));
      }
      else {
        $("#response-screen").show();
        document.getElementById("response-screen").innerHTML = "Please fill in All Required fields"
        $("#response-screen").delay(5000).hide(1000);
      }
    }
   
  }
  getActiveAccounts() {

    this.beneficiaryService.getActiveBeneficiaryAccounts(localStorage.getItem("AgencyId")).subscribe((data) => {
      
      this.allData$ = data;
      this.accounts$ = of(this.allData$.accounts);
      let active = new ActiveAgencies();
      active.agencyId = "ALL";
      active.agencyName = "ALL";
      this.allData$.agencies.push(active);
      this.agencies$ = of(this.allData$.agencies);
    });
  }
  cancel() {
    this.accAllocationObj = new BeneficiaryAccountAllocationProperties();
  }

 

  getAgencyRightsData() {
    try {

      this.vari = localStorage.getItem("AgencyId")
      this.agencyService.GetAgencyRightsById(this.vari).subscribe((data) => {
        this.agencyRightsData = data;
      });
    }
    catch (e) { }
  }

  getBeneficiaryAllocationData(value: string) {
    try {
     // 
      this.beneficiaryService.getBeneficiaryAccAllocation(value).subscribe((data) => { this.beneficiaryAllocationData = data; });
    }
    catch (e) {  }
  }
  editBeneficiaryAllocation(allocationId: number) {
    try {
      this.beneficiaryService.getBeneficiaryAccAllocationById(allocationId).subscribe((data) => { this.accAllocationObj = data[0] as BeneficiaryAccountAllocationProperties; });
    }
    catch (e) {
      //console.log(e);
    }
  }
  changeStatus(allocationId: number, isActive: boolean) {
    try {
      this.beneficiaryService.statusChangeBeneficiaryAccAllocation(allocationId, isActive).subscribe((data) => {
        this.getBeneficiaryAllocationData(localStorage.getItem("AgencyId"));
        //console.log(data);
      });
    }
    catch (e) {
      //console.log(e);
    }
  }
  DeleteBenificiaryAccount(allocationId: number) {
    try {
     this.beneficiaryService.DeleteBeneficiaryAccAllocation(allocationId).subscribe((data) => {
        this.getBeneficiaryAllocationData(localStorage.getItem("AgencyId"));
        //console.log(data);
      });
    }
    catch (e) {
      //console.log(e);
    }
  }
}
